import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'content_hub_module';

export function pushHandlerClickData(title, lbsId) {
    const eventOptions = {
        action_location: ACTION_LOCATION,
        content_title: title,
        content_lbsuuid: lbsId,
    };

    return () => pushEdapEvent('content_tile.selected', eventOptions);
}

export const pushHandleNextData = () => {
    const edapData = {
        action_location: ACTION_LOCATION,
        event_action: 'nav_next_click',
    };

    pushEdapEvent('ux.cards_visible.adjusted', edapData);
};

export const pushHandlePrevData = () => {
    const edapData = {
        action_location: ACTION_LOCATION,
        event_action: 'nav_previous_click',
    };

    pushEdapEvent('ux.cards_visible.adjusted', edapData);
};
